import ChildParentIncome from '../dto/ChildParentIncome';
import Error from '../model/Error';
import axios from 'axios';
import moment from 'moment';

export default class ChildParentIncomeRepository {
    static find(childParentIncomeId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/child-parent-incomes/${childParentIncomeId}`)
                .then((response) => resolve(ChildParentIncome.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findByChild(childId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/children/${childId}/child-parent-income`)
                .then((response) => resolve(response.data.data.map((data) => ChildParentIncome.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static create(childParentIncome, childId) {
        const data = {
            start: moment(childParentIncome.start, 'DD.MM.YYYY').format('YYYY-MM-DD'),
            highestRate: childParentIncome.highestRate,
            parentIncome1: childParentIncome.parentIncome1,
            parentIncome2: childParentIncome.parentIncome2,
        };
        return new Promise((resolve, reject) => {
            axios
                .post(`/children/${childId}/child-parent-income`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static invalidate(childParentIncomeId) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/child-parent-incomes/${childParentIncomeId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
